import { v4 as uuid } from "uuid";
import * as UserConst from "actions/userConst";
import { useSelector, useDispatch } from 'react-redux'

import store from '@/redux/store';
import { createSlice, nanoid, createAsyncThunk } from '@reduxjs/toolkit'
import UserAPI from "@/api/UserAPI";

import { show } from '@/reducers/Modal'
import * as CONST from "@/actions/globalConst";
import DB from "@/models/DB";
import  {UserModel} from "@/models/User";
import  {WorkerModel} from "@/models/PPC/Worker";
import {AddressModel} from "@/models/Address";

import { NotificationModel } from "@/models/Notification";
import {add} from "@/reducers/NotificationReducer";

export const initialState = {
  showModal: "",
  isInProgress: false,
  showSheet: false,
  status: UserConst.USER_STATE_IDLE,
  users: false,
  selected: false,
  key: "",
  interests: [],
  experience: [],
  user_interests: [],
  user_experience: [],
  roles: [],
};


export const loadUsers = createAsyncThunk(
  UserConst.LOAD_INTERN_USER,
  // The payload creator receives the partial `{title, content, user}` object
  async (usertype, event) => {
      //const {UserReducer, rejectWithValue} = event.getState();
      let response = null;
      try {
      response = await UserAPI.get(usertype);
      return response.data;
    } catch (err) {

      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
      return response;
  }
)

export const savePerson = createAsyncThunk(
  UserConst.SAVE_PERSON,
  // The payload creator receives the partial `{title, content, user}` object
  async (data, event) => {
      //const {UserReducer, rejectWithValue} = event.getState();
      let response = null;
      try {
      response = await UserAPI.storePerson(data);
      return response.data;
    } catch (err) {

      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
      return response;
  }
)

export const exportUser = createAsyncThunk(
  UserConst.EXPORT_USER,
  // The payload creator receives the partial `{title, content, user}` object
  async (data, event) => {
      //const {UserReducer, rejectWithValue} = event.getState();
      let response = null;
      try {
      response = await UserAPI.exportUserData(data);
      return response.data;
    } catch (err) {

      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
      return response;
  }
)


export const loadUser = createAsyncThunk(
  UserConst.LOAD_USER,
  // The payload creator receives the partial `{title, content, user}` object
  async (userId, event) => {
      //const {UserReducer, rejectWithValue} = event.getState();
      let response = null;
      try {
      response = await UserAPI.getUser( userId );
      return response.data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
      return response;
  }
)


export const addUser = createAsyncThunk(
  UserConst.NEW_USER,
  // The payload creator receives the partial `{title, content, user}` object
  async (initialPost, event) => {
      //const {UserReducer, rejectWithValue} = event.getState();
      let response = null;
      try {
        
      response = await UserAPI.storeUser( initialPost.getData() ).then((response) => {
                         return response;
      });
      return response.data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
      return response;
  }
)

export const removeUser = createAsyncThunk(
  UserConst.REMOVE_USER,
  // The payload creator receives the partial `{title, content, user}` object
  async (userData:any, event) => {
      //const {UserReducer, rejectWithValue} = event.getState();
      let response = null;
      try {
      response = await UserAPI.deleteUser( userData );
      return response.data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
      return response;
  }
)

export const cretaeOTPRequest = createAsyncThunk(
  'cretaeOTPRequest',
  // The payload creator receives the partial `{title, content, user}` object
  async (userData:any, event) => {
      //const {UserReducer, rejectWithValue} = event.getState();
      let response = null;
      try {
      response = await UserAPI.cretaeOTPRequest( userData );
      return response.data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
      return response;
  }
)

export const getUserInterests = createAsyncThunk(
  UserConst.USER_INTERESTS,
  // The payload creator receives the partial `{title, content, user}` object
  async (userKey, event) => {
      //const {UserReducer, rejectWithValue} = event.getState();

      let response = null;
      try {
          if(!userKey) {
          userKey = store.getState().AuthReducer.user.key;
          }
      response = await UserAPI.getUserInterests( userKey );
      return response.data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
      return response;
  }
)

export const getUserExperience = createAsyncThunk(
  UserConst.USER_EXPERIENCE,
  // The payload creator receives the partial `{title, content, user}` object
  async (userKey, event) => {
      //const {UserReducer, rejectWithValue} = event.getState();

      let response = null;
      try {
          if(!userKey) {
          userKey = store.getState().AuthReducer.user.key;
          }
      response = await UserAPI.getUserExperience( userKey );
      return response.data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
      return response;
  }
)


export const saveUserInterests = createAsyncThunk(
  UserConst.SAVE_USER_INTERESTS,
  // The payload creator receives the partial `{title, content, user}` object
  async (data, event) => {
      //const {UserReducer, rejectWithValue} = event.getState();

      let response = null;
      try {
          if(!data.userKey) {
          data.userKey = event.getState().AuthReducer.user.key;
          }
      response = await UserAPI.saveUserInterests( data );
      return response.data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
      return response;
  }
)

export const saveUserExperience = createAsyncThunk(
  UserConst.SAVE_USER_EXPERIENCE,
  // The payload creator receives the partial `{title, content, user}` object
  async (data, event) => {
      //const {UserReducer, rejectWithValue} = event.getState();

      let response = null;
      try {
          if(!data.userKey) {
          data.userKey = event.getState().AuthReducer.user.key;
          }
      response = await UserAPI.saveUserExperience( data );
      return response.data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
      return response;
  }
)

const UserReducer = createSlice({
  name: 'user',
  initialState,
  reducers: {
      setMapId(state, action) {
          if(action.type == "posts/setMapId") {
            state.selectedMap = action.payload.mapId

            filterOnFile(state);
        }

    },
        unsetSelected(state, action) {
            let user = new UserModel(null, action.payload.type);
            user.createAddress();
            state.selected = user;
        },
        setData(state, action) {
            let user = new UserModel(null, action.payload.type);
            user.createAddress();
            state.selected = user;
            state.key = uuid().slice(0, 8);
        }

    // omit existing reducers here
  },
  extraReducers(builder) {
     builder.addCase(getUserInterests.fulfilled, (state, action) => {

      // We can directly add the new post object to our posts array
      state.status = UserConst.USER_STATE_IDLE
        state.interests = action.payload.data.data;
        state.user_interests = action.payload.data.user_interest;
        state.key = uuid().slice(0, 8);
    });

     builder.addCase(getUserExperience.fulfilled, (state, action) => {
      // We can directly add the new post object to our posts array
      state.status = UserConst.USER_STATE_IDLE
        state.experience = action.payload.data.data;
        state.user_experience = action.payload.data.user_experience;
        state.key = uuid().slice(0, 8);
    });

     builder.addCase(saveUserInterests.fulfilled, (state, action) => {
      // We can directly add the new post object to our posts array
    });

     builder.addCase(removeUser.fulfilled, (state, action) => {
      // We can directly add the new post object to our posts array
        state.status = UserConst.USER_STATE_IDLE
        state.error = null;
        state.users = action.payload.data.data.original.data;
    });


     builder.addCase(addUser.fulfilled, (state, action) => {
      // We can directly add the new post object to our posts array
        state.status = UserConst.USER_STATE_IDLE
        state.error = null;
        state.selected = null;
        state.key = uuid().slice(0, 8);

    }).addCase(addUser.rejected, (state, action) => {
        state.status = UserConst.USER_STATE_ERROR
        state.error = action.payload;
      })

     builder.addCase(loadUsers.fulfilled, (state, action) => {
      // We can directly add the new post object to our posts array
        state.status = UserConst.USER_STATE_IDLE
        state.error = null;
        state.users = DB.newCollection(action.payload.data.data, WorkerModel);
        if(action.payload.data.roles) {
            state.roles = action.payload.data.roles;
        }


    }).addCase(loadUsers.rejected, (state, action) => {
        state.status = UserConst.USER_STATE_ERROR
        state.error = action.payload;
      })

     builder.addCase(loadUser.fulfilled, (state, action) => {
         let userData = DB.newModel(action.payload.data.data, WorkerModel);
         
        if(userData.address && Array.isArray(userData.address) && userData.address.length ==  0) {
            //let newAddress = [];
            userData.address.push(new AddressModel());
            //data.address = newAddress;
        }
        /*
        let userRoles = [];
         if(userData?.roles && userData?.roles.length > 0) {
             userData?.roles.forEach((role) => {
                 
                 
                 userRoles.push(state.roles[role.key]);
                 
             });

             userData.roles = userRoles;
             
         }
         */
      // We can directly add the new post object to our posts array
        state.status = UserConst.USER_STATE_IDLE
        state.error = null;
        state.selected = userData;
        state.key = uuid().slice(0, 8);

    }).addCase(loadUser.rejected, (state, action) => {
        state.status = UserConst.USER_STATE_ERROR
        state.error = action.payload;

      })

    builder.addMatcher(
      (action) => action.type == "switchtenant/pending",
      (state, action) => {
        state.status = UserConst.USER_STATE_IDLE;
        state.users = false;
        state.selected = false;
        state.interests = [];
        state.user_interests = [];
        state.roles = [];
        state.showModal = "";

       })

    builder.addMatcher(
      (action) => action.type.endsWith('/receiveMessage'),
      (state, action) => {
          let item = JSON.parse(action.payload.event.data);
            if(item.type == "TEST") {
                state.selected = item.payload;
                state.key = uuid().slice(0, 8);
            }
       });


  }
})
export const { unsetSelected,setData } = UserReducer.actions;
export default UserReducer.reducer
